
export default {
  // Reviews
  "edit_review": "Editar Reseña",
  "review": "Reseña",
  "film_friendly_score": "Puntuación de Amigabilidad para Película",
  "hand_check": "Revisión Manual",
  "successful": "Exitoso",
  "unsuccessful": "Sin éxito",
  "delete_review": "Eliminar Reseña",
  "review_by": "Reseña por",
};
